export const dashInvoices = {
  invoices: {
    title: "Faktury do wystawienia",
    subtitle: "Tutaj pojawiają się prośby oczekujące na wystawienie faktury.",
    loading: "Wczytywanie…",
    empty: "Brak faktur do wysłania.",
    guestFallback: "Gość",
    manualBadge: "Ręcznie",
    manualBadgeTitle: "Nie jest generowana automatycznie: trzeba ją wystawić ręcznie",
    manualCheckoutTitle: "Nie jest generowana automatycznie: wystaw ją ręcznie",
    linkSentTitle: "Link wysłany do gościa",
    linkPendingTitle: "Link zostanie wysłany w dniu check-out",
    manualIssue: "Wystawienie ręczne",
    sendLinkTitle: "Wyślij gościowi link do uzupełnienia danych do faktury",
    resend: "Wyślij ponownie",
    sendLink: "Wyślij link",
    closeRequestTitle: "Zamknij tę prośbę (faktura wystawiana ręcznie)",
    close: "Zamknij",
    cancelAutoTitle: "Anuluj wysyłkę automatyczną, aby wysłać fakturę ręcznie w inny sposób",
    cancel: "Anuluj",
    viewAll: "Zobacz wszystkie faktury",
    confirmCancel: {
      title: "Anulować automatyczną wysyłkę?",
      html: "Link do faktury nie zostanie wysłany do gościa.<br>Będzie można wysłać go ręcznie w inny sposób.",
      confirm: "Tak, anuluj",
      cancel: "Nie",
    },
    confirmSend: {
      title: "Wysłać link do faktury?",
      html: "Link do uzupełnienia danych podatkowych zostanie wysłany gościowi przez WhatsApp.<br>Fakturę wystawia się ręcznie.",
      confirm: "Tak, wyślij",
      cancel: "Nie",
    },
    cancelError: {
      title: "Nie udało się anulować",
    },
    closeError: {
      title: "Nie udało się zamknąć",
    },
    sendError: {
      title: "Nie udało się wysłać",
    },
    sendSuccess: {
      title: "Link wysłany",
      text: "Gość otrzymał link do faktury.",
    },
    retry: "Spróbuj ponownie.",
  },
  balances: {
    title: "Salda do zapłaty",
    subtitle: "Rezerwacje z kwotą do zapłaty.",
    total: "Razem",
    paid: "Płatność zrealizowana",
    loading: "Wczytywanie…",
    empty: "Brak sald do zapłaty.",
    emptySub: "Gdy rezerwacja będzie mieć kwotę do zapłaty, pojawi się w tym miejscu.",
    viewAll: "Zobacz wszystkie salda",
  },
  balancesDrawer: {
    title: "Salda do zapłaty",
    close: "Zamknij",
    from: "Od",
    to: "Do",
    sort: "Sortuj",
    sortArrival: "Data check-in",
    sortProximity: "Bliskość przyjazdu",
    searchPlaceholder: "Szukaj obiektu…",
    allAccommodations: "Wszystkie obiekty",
    noResults: "Brak wyników",
    clear: "Wyczyść",
    totalPending: "Łącznie do zapłaty",
    ofTotal: "z {amount} {currency}",
    loading: "Wczytywanie…",
    empty: "Brak rezerwacji z kwotą do zapłaty.",
    end: "To wszystko.",
    tags: {
      ended: "Pobyt zakończony",
      now: "Na miejscu",
      today: "Przyjazd dzisiaj",
      tomorrow: "Przyjazd jutro",
      dayAfter: "Przyjazd za 2 dni",
    },
  },
};
